import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { CategoryService, NeedRequestDto, FamilyService } from 'src/app/backend';
import { BasePagedComponent } from 'src/app/core/components/base-paged/base-paged.component';
import { NeedService } from '../../../backend/api/need.service';
import { MemberRequestDto } from '../../../backend/model/memberRequestDto';
import { SexEnum } from '../../../backend/model/sexEnum';
import { BaseComponent } from '../../../core/components/base/base.component';
import { DialogRef } from '../../../core/dialog/dialog-ref';
import { DialogConfig } from '../../../core/dialog/dialog.service';
import { AuthService } from '../../../core/services/auth.service';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';

interface UserRow {
  id: number;
  representative: string;
  phone: string;
  address: string;
  city: string;
}

interface CategoryRow {
  id: number;
  name: string;
}

@Component({
  templateUrl: './save-need-dialog.component.html',
  //   styleUrls: ['./save-user-dialog.component.scss'],
})

export class SaveNeedDialogComponent extends BasePagedComponent implements OnInit {
  dataFamilies: UserRow[] = [];
  searchQueryControl = new UntypedFormControl('');
  active = new UntypedFormControl();
  form = new UntypedFormGroup({});
  id = 0;
  familyId = 0;
  title = new UntypedFormControl();
  description = new UntypedFormControl();
  isLoading = false;
  isSaving = false;

  constructor(
    private dialogConfig: DialogConfig,
    private dialogRef: DialogRef,
    private t: TranslateService,
    private needService: NeedService,
    private familiesService: FamilyService,
    private categoriesService: CategoryService,
    authService: AuthService,
    messageService: NzMessageService
  ) {
    super(authService, t, messageService);
    const config = this.dialogConfig;
    this.id = config.data?.id;
    this.familyId = config.data?.familyId;

    this.form = new UntypedFormGroup({
      title: new UntypedFormControl(''),
      description: new UntypedFormControl(''),
      familyId: new UntypedFormControl(this.familyId),
      active: new UntypedFormControl (0),
      needDate: new UntypedFormControl(0),
      id: new UntypedFormControl(0),
    });

    if (this.id) {
      this.loadNeed(this.id);
    }
    this.loadFamilies();
  }

  ngOnInit() {
  }

  loadNeed(id: number) {
    this.isLoading = true;

    this.needService.apiNeedIdGet({ id }).subscribe(
      (res) => {
        console.log(res);
        this.isLoading = false;
        this.form.patchValue({
          title: res.title,
          description: res.description,
          familyId: res.familyId,
          active: res.active,
          needDate: res.needDate,
          id: res.id
        });
      },
      () => {
        this.isLoading = false;
        this.close();
      }
    );
  }

  close(saved?: boolean) {
    this.dialogRef.close({ saved });
  }

  save() {
    if (!this.form.valid) {
      for (const i in this.form.controls) {
        this.form.controls[i].markAsDirty();
        this.form.controls[i].updateValueAndValidity();
      }
      return;
    }

    const data: NeedRequestDto = {
      familyId: this.form.value.familyId || this.familyId,
      title: this.form.value.title,
      description: this.form.value.description,
      needDate: this.form.value.needDate,
      id: this.form.value.id,
      active: this.form.value.active
    };

    const apiCall = this.id
      ? this.needService.apiNeedPut({
        needRequestDto: data,
        })
      : this.needService.apiNeedPost({ needRequestDto: data });

    this.isSaving = true;

    apiCall.subscribe(
      (res: any) => {
        this.isSaving = false;
        this.close(true);
      },
      (err: any) => {
        this.isSaving = false;
        this.errorHandler(err, this.form);
      }
    );
  }

  disabledEndDate = (endValue: Date): boolean => {
    if (endValue.getDate() < new Date().getDate()) {
      return false;
    }

    return true;
  }

  loadFamilies() {
    this.isLoading = true;

    this.familiesService
      .apiFamilyGet({
        query: this.searchQueryControl.value,
        isFullSize: true,
        orderByKey: 'Representative'
      })
      .subscribe(
        (res) => {
          console.log('Porodice');
          console.log(this.familyId);

          this.isLoading = false;
          this.dataFamilies =
            res.results?.map((x) => ({
              id: x.id || 0,
              representative: x.representative || '',
              phone: x.phone || '',
              address: x.address || '',
              city: x.city || '',
            })) || [];
        },
        (err) => {
          this.isLoading = false;
        }
      );
  }
}
